import SommaireJson from "./Sommaire.json";
import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import "./Sommaire.css";
import translations from "./Texte";

import React, { useContext, useEffect } from 'react';
import { SharedVariableContext } from '../../App';

export default function SommaireTest() 
{
    const [categories] = useState(SommaireJson);
    const { MajTypeDePage, MajIllustration, selectedOption } = useContext(SharedVariableContext);

    const scrollContainerRef = useRef(null); // Référence à la div de défilement
    
    // Mettre à jour la variable partagée
    useEffect(() => {
                    MajTypeDePage('Sommaire');
                    MajIllustration('Sommaire');
                    }, [MajTypeDePage, MajIllustration]);


    // Sélectionner la langue, avec français comme langue par défaut
    const lang = translations[selectedOption.value] || translations.fr;


// Gestion du scroll horizontal à la roulette
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;

    // Vérifier que scrollContainer existe
    if (!scrollContainer) {
      console.error("scrollContainer is null, la div .sommaire n'est pas trouvée.");
      return;
    }

    // Vérifier que la div est dans le DOM
    console.log("scrollContainer trouvé :", scrollContainer);

    // Fonction pour vérifier si on est sur desktop (par exemple, largeur > 1024px)
    const isDesktop = () => window.innerWidth > 1024;

    // Gestionnaire d'événement pour la roulette
    const handleWheel = (event) => {
      if (isDesktop()) {
        event.preventDefault(); // Empêche le défilement vertical par défaut
        scrollContainer.scrollLeft += event.deltaY; // Défilement horizontal
        console.log("Wheel event triggered, scrollLeft:", scrollContainer.scrollLeft);
      }
    };

    // Ajouter l'événement wheel
    scrollContainer.addEventListener("wheel", handleWheel, { passive: false });

    // Nettoyer l'événement lors du démontage du composant
    return () => {
      scrollContainer.removeEventListener("wheel", handleWheel);
    };
  }, []); // Pas de dépendance sur categories pour éviter des réattachements inutiles

  // Vérification de categories avant le rendu
  if (!categories || !Array.isArray(categories) || categories.length === 0) {
    console.error("SommaireJson est invalide ou vide :", categories);
    return (
      <div id="Sommaire">
        <h1>Sommaire</h1>
        <p>Erreur : Aucun contenu disponible pour le sommaire.</p>
      </div>
    );
  }



    return (
        <div id="Sommaire">
        <h1>{lang.title}</h1>
        <p>{lang.p1}</p>
        <div className="sommaire">
            {categories.map((category, index) => (
            <div className='computer' key={index}>
                <div className="categorie">{category.text}</div>
                <div className="sousCategories">
                {category.articles.map((article, subIndex) => (
                    <div className="article" key={subIndex}>
                    
                        <Link to={article.lien} aria-label={`Accéder à ${article.text}`}><div className="articleName">{article.text}</div></Link>
                    
                    {article.lien === "/EnConstruction" && (
                    <div className="enConstruction">A venir</div>
                    )}
                    </div>
                ))}
                </div>
            </div>
            ))}
        </div>
        </div>
    );
}